import { User } from "../../api/accessControl/User.ts";
import { useSearchParams } from "react-router-dom";
import { Header } from "../../components/general/Header.tsx";
import { useStartBankSync } from "./useStartBankSync.ts";
import { ErrorState, LoadingState, SuccessState } from "./SyncBankDataStates.tsx";

export function SyncBankDataPage({ currentUser }: { currentUser: User }) {
    const [searchParams] = useSearchParams();
    const ref = searchParams.get('ref');

    const {
        hasJobStarted,
        progress,
        totalTransactions,
        error,
        isFinished
    } = useStartBankSync(ref, currentUser.getToken());

    if (!ref) {
        return (
            <div className="p-8 text-center">
                Something went wrong. Please contact us via hello@pocketcfo.io | CODE: ERR234235
            </div>
        );
    }


    const renderContent = () => {
        if (error) return <ErrorState error={error} />;
        if (isFinished) return <SuccessState totalTransactions={totalTransactions} />;
        return <LoadingState hasJobStarted={hasJobStarted} progress={progress} />;
    };

    return (
        <div className="min-h-screen mt-16">
            <Header />
            <main className="bg-white py-24 sm:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    {renderContent()}
                </div>
            </main>
        </div>
    );
}
